import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import ButtonPrimary from 'components/ButtonPrimary/index.js'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import logEventAnalyticsUtil from 'modules/analytics/utils/log-event/index.js'
import { hasPremiumUserSelect } from 'modules/training/modules/training-users/selectors/has-premium/index.js'
import isPremiumUrlRouterSelect from 'modules/router/selectors/is-premium/index.js'
import openAppSignInModalAction from 'modules/modal/actions/open-app-sign-in/index.js'
import { hasSeenOnboardingModalRecentlyProfileUtil } from 'modules/profile/utils/hasSeenOnboardingModalRecently/index.js'

const messages = defineMessages({
  getStarted: {
    id: 'FeatureCTA.getStarted',
    defaultMessage: 'Get started'
  }
})

const ANALYTIC_EVENT = {
  FEATURES_GET_STARTED: 'FEATURES_GET_STARTED',
  FEATURES_OPEN_LOGIN: 'FEATURES_OPEN_LOGIN',
  FEATURES_OPEN_LOGIN_PREMIUM_PAGE: 'FEATURES_OPEN_LOGIN_PREMIUM_PAGE'
}

/**
 * @returns {JSX.Element}
 * @constructor
 */
export const FeatureCTA = () => {
  const dispatch = useDispatch()
  const intl = useIntl()
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const hasPremium = useSelector(hasPremiumUserSelect)
  const isPremiumPage = useSelector(isPremiumUrlRouterSelect)
  const hasSeenOnboardingRecently = hasSeenOnboardingModalRecentlyProfileUtil()

  const handleClick = () => {
    if (isPremiumPage) {
      logEventAnalyticsUtil(ANALYTIC_EVENT.FEATURES_OPEN_LOGIN_PREMIUM_PAGE)
      dispatch(openAppSignInModalAction())
    } else if (hasSeenOnboardingRecently) {
      logEventAnalyticsUtil(ANALYTIC_EVENT.FEATURES_OPEN_LOGIN)
    } else {
      logEventAnalyticsUtil(ANALYTIC_EVENT.FEATURES_GET_STARTED)
    }
  }

  // Don't show if user already has premium
  if (hasPremium) {
    return null
  }

  // If on premium page, no URL (will open modal instead)
  // Otherwise, use openLogin if seen onboarding recently, else showOnboarding
  const actionParam = hasSeenOnboardingRecently ? 'openLogin=true' : 'showOnboarding=true'
  const ctaUrl = isPremiumPage
    ? undefined
    : `${ROUTE_PATH.ACCOUNT}?${actionParam}`

  return (
    <View
      style={{
        margin: isSmallScreen ? '2rem auto 0' : '2rem 0'
      }}
    >
      <ButtonPrimary
        url={ctaUrl}
        onClick={handleClick}
        style={{
          margin: '0 auto'
        }}
      >
        {formatMessageIntlUtil(intl, messages.getStarted)}
      </ButtonPrimary>
    </View>
  )
}
